module.exports = __webpack_public_path__ + "img/accidentecoche.f7564fd1.jpg";